// extracted by mini-css-extract-plugin
module.exports = {"price":"_4f720283bf--price--UqdxG"};